export type Site = 'smartbench' | 'vantage';

/**
 * Derives the active site (which header banner and navigation to render) from the current URL.
 *
 * All SmartBench screens are nested under the `/sb` route; every other route is Vantage, so the
 * URL is the single source of truth for the active site. Deriving from anything else — e.g.
 * latching the previously-selected site — makes the header stick to the wrong site after the user
 * switches, which is exactly the bug this replaced.
 * @param pathname - The current location pathname (e.g. from react-router's `useLocation`).
 * @returns `'smartbench'` for `/sb` routes, otherwise `'vantage'`.
 */
export const deriveSiteFromPath = (pathname: string): Site =>
  pathname.startsWith('/sb') ? 'smartbench' : 'vantage';
